import React from 'react'
import { withRouter } from 'react-router-dom'

import { AuthContext } from '../../main/authProvider'

import Card from '../../components/card'
import TipoDePagamentoService from '../../app/service/contasAPagar/tipoDePagamentoService'
import TipoDePagamentoComponent from './tiposDePagamentoComponent'
import TipoDePagamentoTable from '../../components/contasAPagar/tipoDePagamentoTable'
import CreateTipoDePagamentoDialog from './createTipoDePagamentoDialog'
import { Button } from 'primereact/button'
import HandleErrorService from '../../app/service/handleErrorService'

class TipoDePagamento extends React.Component{

    constructor(){
        super();
        this.tipoDePagamentoService = new TipoDePagamentoService();
        this.inputNome = React.createRef();
    }    

    state = {
        tipoDePagamentoList: [],
        loading: false,
        displayCadastroTipoDePagamentoDialog: false,
    }

    componentDidMount(){
        this.search()
    }

    search = () => {
        this.setState({loading: true})

        this.tipoDePagamentoService.search()
        .then(response => {
            const list = response.data
            this.setState({tipoDePagamentoList: list})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally( () => {
            this.setState({loading: false})
        } )        
    }    

    handleNewFornecedorCadastrado = () => {
        window.location.reload()
    }

    hideCadastroTipoDePagamentoDialog = () => {
        this.setState({displayCadastroTipoDePagamentoDialog: false})
    }

    

    render(){

        const renderCadastrarButton = () => {
            if(!this.props.simpleView){
                return (
                    <>
                        <Button
                            label="Cadastrar"
                            icon="pi pi-plus"
                            onClick = {() => this.setState({displayCadastroTipoDePagamentoDialog: true})}
                            style={ {maxWidth: '200px' } }
                        />

                        <br />

                        <br />                    
                    </>
                )
            }
        }        

        return(
            <div className="bs-docs-section" >
            <Card title = "Tipos De Pagamento">
            <div className = "col-md-12">
                
            {/* <TipoDePagamentoComponent
                handleNewFornecedorCadastrado={this.handleNewFornecedorCadastrado}
            /> */}

                {renderCadastrarButton()}

                <TipoDePagamentoTable
                    list = {this.state.tipoDePagamentoList}
                    loading = {this.state.loading}
                    search={this.search}
                    emptyMessage="Não há Tipos de Pagamento Cadastrados"
                />

                <CreateTipoDePagamentoDialog
                    visible={this.state.displayCadastroTipoDePagamentoDialog}
                    search={this.search}
                    hideDialog={this.hideCadastroTipoDePagamentoDialog}
                    handleNewFornecedorCadastrado={this.handleNewFornecedorCadastrado}
                />            

            </div>
            </Card>
            <div className="d-flex "/>
            </div>
        )
    }

}

TipoDePagamento.contextType = AuthContext
export default withRouter( TipoDePagamento )